import {UntypedFormGroup} from '@angular/forms';

export class ImageTypeValidation {

  static ValidateType(key: string) {
    return (group: UntypedFormGroup): { [key: string]: any } => {
      const imageInput = group.controls[key];
      const image = imageInput.value;

      const imageMimeType: RegExp = new RegExp(/image/);
      let imageFileType;

      if (imageMimeType.test(image)) {
        // Split the base64 string in data and contentType
        const block = image.split(";");
        // Get the content type (ex.: image/png)
        const dataType = block[0].split(":")[1];
        // Get the image file type (ex.: png)
        imageFileType = dataType.split("/")[1];
      }

      if (image && imageMimeType.test(image) && (imageFileType !== 'jpeg' && imageFileType !== 'jpg' && imageFileType !== 'png' && imageFileType !== 'gif')) {
        return {
          invalidImageType: true
        };
      }
      return null;
    }
  }

}
